import { OrganizationInviteStatusV2Dto, ReceivedBidV2Dto, SourcingEventV2Dto } from "../../../autogen/bff-api";

export interface SupplierRow {
  organizationId: string;
  // Empty for private invite rows — the invite only carries the id, so the table resolves the name.
  organizationName: string;
  registeredAt?: string;
  inviteStatus?: OrganizationInviteStatusV2Dto;
  bid?: ReceivedBidV2Dto;
}

export const buildSupplierRows = (
  event: SourcingEventV2Dto,
  bids: ReceivedBidV2Dto[],
): SupplierRow[] => {
  const byOrg = new Map<string, SupplierRow>();

  for (const registration of event.supplierRegistrations ?? []) {
    byOrg.set(registration.organizationId, {
      organizationId: registration.organizationId,
      organizationName: registration.organizationName,
      registeredAt: registration.registeredAt,
    });
  }

  const privateContext = event.eventContext.type === "Private" ? event.eventContext : null;
  for (const invite of privateContext?.organizationInvites ?? []) {
    byOrg.set(invite.organizationId, {
      organizationId: invite.organizationId,
      organizationName: "",
      inviteStatus: invite.status ?? OrganizationInviteStatusV2Dto.Invited,
    });
  }

  for (const bid of bids) {
    const existing = byOrg.get(bid.owner);
    if (existing) {
      existing.bid = bid;
    } else {
      byOrg.set(bid.owner, {
        organizationId: bid.owner,
        organizationName: bid.ownerName,
        bid,
      });
    }
  }

  return Array.from(byOrg.values()).sort((a, b) =>
    a.organizationName.localeCompare(b.organizationName),
  );
};

export const isBidDeadlinePassed = (event: SourcingEventV2Dto): boolean => {
  const deadline = event.milestoneDates?.bidSubmissionDeadline;
  return deadline != null && new Date(deadline).getTime() <= Date.now();
};
